import { Container, Content, ContentFinally } from "./styles";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaMapMarkerAlt, FaPhoneAlt, FaRegCopyright } from 'react-icons/fa';
import { GoToTop } from "../../GoToTop";
import logo from "../../assets/redesign/images/logo.png";

export function Footer() {
    return (
        <Container>
            <Content>
                <div className="col-1">
                    <img src={logo} alt="Logomarca Nogueira" />
                    {/* <p className="endereco">Rua Antônio Lumack do Monte, 128 - sala 1401 Recife-PE</p> */}
                    <p className="contato-tel"><FaPhoneAlt /> {" "}<strong>Telefone: (81) 3019-3333</strong></p>
                    <p className="creci"><strong>CRECI: 17135-J</strong></p>
                </div>
                <div className="col-2">
                    <h3>Links rápidos</h3>
                    <div className="content-links">
                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Link className="links" to='/sobre'> Sobre nós</Link></h3>
                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Link className="links" to='/ouvidoria'> Ouvidoria</Link></h3>
                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Link className="links" to='/trabalhe-conosco'> Trabalhe Conosco</Link></h3>
                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Link className="links" target="_blank" to='https://www.caixa.gov.br/voce/habitacao/financiamento-de-imoveis/Paginas/default.aspx'> Solicitar Financiamento</Link></h3>
                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Link className="links" target="_blank" to='https://portal-de-consulta-lgpd.vercel.app/'> Lei Geral de Proteção de Dados - LGPD</Link></h3>
                    </div>
                </div>
                <div className="col-3">
                    <h3>Horário de funcionamento</h3>
                    <div className="content-col-3">
                        <p className="times">Seg. a Sex. - 8:00 às 20:00</p>
                        <p className="times">Sáb. - 08:00 às 16:00</p>
                        <p className="times">Dom. - 08:00 às 14:00</p>
                    </div>
                </div>
                <div className="col-4">
                    <h3>Endereços</h3>
                    <div className="content-col-4">
                        <div className="icon-and-text">
                            <FaMapMarkerAlt className="icon-1" />
                            <div className="infos-address">
                                <p className="title">Hub Nogueira Center II</p>
                                <p>Rua Antônio Lumack do Monte, 96 - sala 1201</p>
                                <p>Empresarial Center II - Boa Viagem - Recife/PE</p>
                            </div>
                        </div>
                        <div className="icon-and-text">
                            <FaMapMarkerAlt className="icon-2" />
                            <div className="infos-address">
                                <p className="title">Hub Nogueira Center III</p>
                                <p>Rua Antônio Lumack do Monte, 128 - sala 1401</p>
                                <p>Empresarial Center III - Boa Viagem - Recife/PE</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
            <ContentFinally>
                <div className="icons">
                    <a style={{ color: 'white' }} href="https://www.facebook.com/p/Hub-Nogueira-Corretores-100087667947215/?locale=pt_BR">
                        <FaFacebook cursor='pointer' />
                    </a>
                    <a style={{ color: 'white' }} href="https://www.linkedin.com/company/nogueira-corretores-de-imóveis/posts/?feedView=all">
                        <FaLinkedin cursor='pointer' />
                    </a>
                    <a style={{ color: 'white' }} href="https://www.instagram.com/hubnogueiracorretores/">
                        <FaInstagram cursor='pointer' />
                    </a>

                    <p style={{ margin: '0px', color: '#ababab', fontSize: '0.8rem' }}>Versão: 1.5.6</p>
                </div>
                <div className="direitos-reservados">
                    <FaRegCopyright color="#fff" />
                    <p>{`${new Date().getFullYear()}`}. Todos os direitos reservados.</p>
                </div>
            </ContentFinally>
            <GoToTop />
        </Container>
    )
}